<template>
 <table class="table">
        <thead class="bg-info text-center">
            <tr class="text-white">
                <td>Name</td>
                <td>Email</td>
                <td>Action</td>
            </tr>
        </thead>
        <tbody  class="bg-secondary text-white text-center">
            <tr v-for="employee in employees" :key="employee.id">
                <td v-if="editing==employee.id">
                    <input type="text" v-model="employee.name" />
                </td>
                <td v-else>{{employee.name}}</td>
                <td v-if="editing==employee.id">
                    <input type="text" v-model="employee.email" />
                </td>
                <td v-else>{{employee.email}}</td>
                <td colspan="2" v-if="editing==employee.id">
                    <button @click="editEmployee(employee)" class="btn btn-sm btn-success text-white">save</button> 
                    <button @click="editing=null" class="btn btn-sm btn-primary text-white">Cancle</button>
                </td>
                <td colspan="2" v-else>
                    <button @click="editMode(employee)" class="btn btn-sm btn-success text-white">Edit</button> 
                    <button @click="$emit('delete:employee',employee.id)" class="btn btn-sm btn-danger text-white">Delete</button>
                </td>
            </tr>
            
        </tbody>
</table>
</template>
<script>

export default {
    name :'employee-table',
    props:{
        employees:Array
    },
    data(){
        return{
            editing:null,
            employee:{
                name:"",
                email:""
            }
        }
    },
    methods:{
        editMode(employee)
        {
            this.editing=employee.id;
        },
        editEmployee(employee)
        {
            if(employee.name==''||employee.email=='')
            {
                return;
            }
            this.$emit('edit:employee',employee.id,employee);
            this.editing=null;
        }
    }
}
</script>
<style scoped>
  .btn-sm{
    margin:0px 4px;
  }
  th,td
  {
    font-size:14px;
  }
  .btn
  {
    font-size:11px;
  }
</style>